import React from 'react'
import './App.css'
import Card from './Components/Card'
import Navbar from './Components/Navbar'
export default function HomePage() {
    return (
        <div className="App">

            <Card />
        </div>
    )
}
